import { simTick, simUpdate } from './simulation';
import data from './data';

/*******************************************/

export function restart(delay = true) {
  // console.log('[RESTART]');
  data.state = 'new';
  this.setPlayClickDisable(true);
  setTimeout(init.bind(this), 0);
}

function init() {
  const exampleIdx = this.state.exampleIdx;

  // init drawing for current example
  // const calcInit = data.examples[exampleIdx].calcInit;
  const calcInit = 'initData';
  // this.setState({
  //   data: calcFunctions[calcInit](exampleIdx),
  // });

  data.state = 'pause';
  this.changePlayState('pause');
  this.setPlayClickDisable(false);
}

/*******************************************/
// play clicked
export function play() {
  const temp = this.state.playState;
  this.setState(state => ({
    playState: state.playState === 'play' ? 'pause' : 'play',
  }));
  data.state = 'in-play';
  if (temp === 'pause') {
    process.bind(this)();
  }
}

// step clicked
export function step() {
  if (this.state.playState !== 'play') {
    this.setState({ busy: true });
  }

  const data = simTick();

  this.setState(state => ({
    data: data,
    busy: false,
  }));
}

function process() {
  // console.log('[PROCESS]');

  const interval = data.examples[this.state.exampleIdx].interval;

  // interval - time between each tick
  clearInterval(this.intervalID);
  // this.intervalID = setInterval(nextData.bind(this), interval);
  this.setState({ startTime: new Date().getTime() / 1000, wallY: data.wallY });
  requestAnimationFrame(nextData.bind(this));

  function nextData() {
    if (data.state === 'new') {
      // clearInterval(this.intervalID);
      this.changePlayState('pause');
      data.state = 'start';
    } else if (this.state.playState === 'play') {
      const time = new Date().getTime() / 1000;
      const delta = time - this.state.startTime;

      if (delta > data.wallOpenTime) {
        this.setState(state => {
          let wallY = (state.wallY += 0.3);
          if (wallY >= data.wallYFinal) {
            wallY = data.wallYFinal;
          }
          setTimeout(() => simUpdate(wallY), 500);
          return {
            wallY,
          };
        });
      }
      step.bind(this)();
      requestAnimationFrame(nextData.bind(this));
    } else {
      // clearInterval(this.intervalID);
      this.changePlayState('pause');
    }
  }
}
